<template>
    <div>
        <h2>落箱单信息</h2>
        <van-form @submit="onSubmit">
            <van-button type="primary" v-if="bill.in_status=='道口提交' || bill.in_status=='叉车提交'">落箱提交成功</van-button>
            <van-button type="danger" v-if="bill.in_status=='司机提交'">落箱道口待处理</van-button>
            <van-button type="primary" v-if="bill.out_status=='道口提交' || bill.out_status=='叉车提交'">提箱提交成功</van-button>
            <van-button type="danger" v-if="bill.out_status=='司机提交'">提箱道口待处理</van-button>
            <van-field v-model="bill.yard_name" label="场地" readonly/>
            <van-field v-model="bill.boxno" label="箱号" readonly/>
            <van-field v-model="bill.box_model" label="箱型" readonly/>
            <van-field v-model="bill.sealno" label="封子" readonly/>
            <van-field v-model="bill.area" label="堆场区" readonly/>
            <van-field v-model="bill.is_sealno" label="是否寄存封子" readonly/>
            <van-field v-model="bill.daibox_fee" label="代箱费" readonly/>
            <van-field v-model="bill.sealno_fee" label="封子费" readonly/>
            <van-field v-model="bill.luobox_fee" label="落箱费" readonly/>
            <van-field v-model="bill.overdue_fee" label="超期费" readonly/>
            <van-field v-model="bill.total_fee" label="费用合计" readonly/>
            <van-field v-model="bill.tel" label="落箱司机电话" readonly/>
            <van-field v-model="bill.in_carno" label="落箱司机车牌" readonly/>
            <van-field v-model="bill.in_date" label="落箱时间" readonly/>
            <van-field v-model="bill.out_tel" label="提箱司机电话" readonly/>
            <van-field v-model="bill.out_carno" label="提箱司机车牌" readonly/>
            <van-field v-model="bill.out_date" label="提箱时间" readonly/>
            <van-field v-model="bill.neardate" label="船期" readonly/>
            <van-field v-model="bill.voyage" label="航次" readonly/>
            <van-field v-model="bill.port" label="码头" readonly/>
        </van-form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Dialog, Form} from 'vant';

    Vue.use(Form);

    export default {
        data() {
            return {
                id: '',
                bill: '',
            };
        },
        methods: {
            onSubmit(values) {

            },
            getBillInfo() {
                let querystring = require('querystring');
                this.$api.post('wx/container-yard/billInfo',
                    querystring.stringify({
                        id: this.id,
                    })
                ).then(data => {
                    if (data.data.status == 1) {
                        this.bill = data.data.data;
                    } else {
                        Dialog.alert({
                            message: data.data.msg,
                        }).then(() => {

                        });
                    }
                }).catch(err => {
                    console.log(err);
                })
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.getBillInfo();
        }
    }
</script>

<style scoped>
    .van-cell {
        height: 0.9rem;
    }

    .van-button {
        height: 0.9rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/container-yard/billInfo.vue